import type { ComponentType } from 'react';
import type { CryptoCashierConfig } from '../../../hooks/payment/resolveCryptoCashierConfig';
import CryptoDepositForm from './CryptoDepositForm';
import CryptoWithdrawForm from './CryptoWithdrawForm';
import ZeroXDepositForm from '../zero-x/ZeroXDepositForm';
import ZeroXWithdrawForm from '../zero-x/ZeroXWithdrawForm';

type CryptoProviderFormProps = { paymentProvider: string | null };

/** The single place that maps the marketplace's crypto provider to its cashier forms. */
export const CRYPTO_PROVIDER_FORMS: Record<
  CryptoCashierConfig['provider'],
  { Deposit: ComponentType<CryptoProviderFormProps>; Withdraw: ComponentType<CryptoProviderFormProps> }
> = {
  moralis: { Deposit: CryptoDepositForm, Withdraw: CryptoWithdrawForm },
  zero_x_processing: { Deposit: ZeroXDepositForm, Withdraw: ZeroXWithdrawForm },
};
